import { render } from "./ProviderBio.vue?vue&type=template&id=6f98b691&scoped=true"
import script from "./ProviderBio.vue?vue&type=script&lang=js"
export * from "./ProviderBio.vue?vue&type=script&lang=js"

import "./ProviderBio.vue?vue&type=style&index=0&id=6f98b691&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f98b691"]])

export default __exports__